import { render, staticRenderFns } from "./ModalDialogValidar.vue?vue&type=template&id=23695556&"
import script from "./ModalDialogValidar.vue?vue&type=script&lang=js&"
export * from "./ModalDialogValidar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports